import { useStorage } from '@elfsight/widget-utils';

export const useRememberVisitorStorage = () =>
  useStorage<number | null>('rememberVisitor', null);

export const useFirstVisitStorage = () =>
  useStorage<number | null>('firstVisit', null);

export const useStartTimeStorage = () =>
  useStorage<string | null>('startTime', null);

export const useNewUserTimeStorage = () =>
  useStorage<number | null>('newUserTime', null);
